import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp, faArrowTrendDown, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import '../styles/companionAppUsageReport.css';

const MetricCard = ({
  metricKey,
  title,
  currentValue,
  previousValue,
  changePercent,
  unit = '',
  isLoading = false,
  helpText = null,
  yearOverYearComparison = false,
  icon
}) => {
  if (isLoading) {
    return (
      <div className="metric-card bg-light">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div style={{ flex: 1 }}>
            <p className="text-muted m-0 small"><Skeleton width="150px" /></p>
          </div>
          <Skeleton circle={true} width="24px" height="24px" />
        </div>
        <h2 className="mb-0"><Skeleton width="100px" height="32px" /></h2>
        {yearOverYearComparison && (
          <>
            <p className="mb-0 small"><Skeleton width="150px" /></p>
            <p className="mb-0 text-muted small"><Skeleton width="120px" /></p>
          </>
        )}
      </div>
    );
  }

  const isNegativeChange = changePercent < 0;
  const tooltipId = `metric-card-tooltip-${metricKey}`;

  return (
    <div className="metric-card bg-light">
      <div className="d-flex justify-content-between align-items-start mb-2">
        <div className="d-flex align-items-center">
          <p className="fw-semibold m-0 text-muted small">{title}</p>
          {helpText && (
            <OverlayTrigger
              key={`metricCard-${metricKey}`}
              placement="top"
              overlay={<Tooltip id={tooltipId} className="custom-tooltip"> {helpText} </Tooltip>}
            >
              <FontAwesomeIcon className="circle-question mx-1" icon={faCircleQuestion} />
            </OverlayTrigger>
          )}
        </div>
        <div>{icon}</div>
      </div>

      <h2 className="fs-2 fw-bold mb-0">
        {currentValue}{unit}
      </h2>

      {yearOverYearComparison && (
        <>
          <p className={`small m-0 ${isNegativeChange ? 'text-danger' : 'text-success'}`}>
            <span className="d-flex align-items-center">
              <FontAwesomeIcon
                icon={isNegativeChange ? faArrowTrendDown : faArrowTrendUp}
                style={{ fontSize: '0.875rem' }}
              />
              <span className="mx-2">
                {Math.abs(changePercent).toFixed(1)}% {isNegativeChange ? 'vs last year' : 'vs last year'}
              </span>
            </span>
          </p>
          {previousValue !== null && previousValue !== undefined && (
            <p className="align-caret-down mb-0 text-muted small">
              Previous: {previousValue}{unit}
            </p>
          )}
        </>
      )}
    </div>
  );
};

MetricCard.propTypes = {
  metricKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  previousValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  changePercent: PropTypes.number,
  unit: PropTypes.string,
  isLoading: PropTypes.bool,
  helpText: PropTypes.node,
  yearOverYearComparison: PropTypes.bool,
  icon: PropTypes.element
};

export default MetricCard;
